import React from 'react'
import { Route, Switch } from 'react-router-dom'
import PageLayout from 'layouts/PageLayout'
import { Error } from 'components'

const AppRouter = () => {
  return (
    <Switch>
      <Route
        path='/iframe/pay-page'
        render={(routeProps) => require('./PayPage').default(routeProps)}
      />
      {require('./Result').default({ match: { path: '/iframe/result' } })}
      <Route path='*'>
        <PageLayout>
          <Error type='404' />
        </PageLayout>
      </Route>
    </Switch>
  )
}

export default AppRouter
